module.exports = __webpack_public_path__ + "img/direction-button-arrows.23835c47.svg";